import React from 'react';

const req = require.context('assets/sprites/', true, /\.svg$/);

const icons = {};

req.keys().forEach(filename => {
    const id = filename.replace('./', '').replace('.svg', '');
    icons[id] = req(filename);
});

const Icons = () => (
    <svg data-svg="sprite" style={{ display: 'none' }} xmlns="http://www.w3.org/2000/svg">
        {Object.keys(icons).map(icon => {
            let Component = icons[icon];
            return <Component className="symbol-icon" key={icon} id={`icon-${icon}`} />;
        })}
    </svg>
);

export default Icons;



// WEBPACK FOOTER //
// ./src/components/Icons/Icons.jsx